
<ng-template [ngIf]="inserimento">
<div class="col-sm-12 coldx" 
	[ngStyle]="{ 'display' : ( visibleToggleAssocia ? 'block' : 'none') }">
	<h4 *ngIf="title">{{title}}</h4>
	<small id="cerca-fatture-form" class="sr-only">cerca fatture</small>
	<form aria-labelledby="cerca-fatture-form" class="cerca_grey">
		<div class="row">
			<p class="col-sm-12">
				<label for="cerca-fatt-frm-lbl">Cerca</label> <input id="cerca-fatt-frm-lbl" type="text" #searchItem (keyup)="0"
					class="form-control" placeholder="Inserisci nome e cognome" />
			</p>
		</div>
	</form>
	<ng-template [ngIf]="altrePartiAll && altrePartiAll.length > 0">
	<ng-template ngFor let-altraParte [ngForOf]="altrePartiAll  | searchFilter : searchItem.value : 'parte.nominativo'">
	<ul id="controparticollapse" class="controparti">
		<li class="panel">
			<div class="controparte">
				<div>
					<p class="col-xs-12 col-sm-2">
						<button class="btn btn-primary associa"
							(click)="associaBeneficiario(altraParte);" type="submit">Associa</button>
					</p>
					<h4 class="titolo col-sm-3">{{ altraParte.parte.nominativo }}</h4>
					<ng-template [ngIf]="altraParte.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
						<p class="col-sm-3">
							C/F: <strong> {{ altraParte.parte.codiceFiscale }} </strong>
						</p>
					</ng-template>
					<ng-template [ngIf]="altraParte.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
						<p class="col-sm-3">
							P.IVA: <strong> {{ altraParte.parte.partitaIva }} </strong>
						</p>
					</ng-template>

					<p class="col-sm-2">
						<strong>{{altraParte.categoriaAltraParte?.label}}</strong>
					</p>
					<ng-template [ngIf]="altraParte.ritirato">
					<p class="col-sm-2 status">NON ATTIVO</p>
					</ng-template>
				</div>
			</div>
		</li>
	</ul>
	</ng-template> </ng-template>
	<ng-template [ngIf]="(!altrePartiAll || altrePartiAll.length == 0) && msgNoBeneficiari">
	<p>{{msgNoBeneficiari}}</p>
	</ng-template>
</div>
</ng-template>

<ng-template [ngIf]="fatturaForm">

<div class="col-sm-12 coldx" 
	[ngStyle]="{ 'display' : ( visibleToggleForm ? 'block' : 'none') }">
	<h4 *ngIf="title">{{title}}</h4>
	<div class="tab-content">
		<form [formGroup]="fatturaForm">
			<div class="row">
				<ng-template [ngIf]="!inserimento">

				<div class="col-sm-6">
					<p>
						<label for="tipo_beneficiario">Tipo beneficiario</label> <select
							name="tipo_beneficiario" class="form-control"
							(change)="populateBeneficiari($event);">
							<ng-template ngFor let-categoria [ngForOf]="categorie">
							<option value="{{categoria.label}}">{{categoria.label}}</option>
							</ng-template>
						</select>
					</p>
				</div>

				<div comboModInput [control]="fatturaForm.controls['altraParte']"
					class="col-sm-6" [labelInput]="'Beneficiario'" formControlName="altraParte"
					[labelOption]="'parte.nominativo'" [objectReference]="request.altraParte"
					(onReturn)="request.altraParte = $event" [optionsCombo] ="altrePartiOptions" [mandatory]="true"
					[ngModel]="request.altraParte"></div>
				</ng-template>

				<ng-template [ngIf]="inserimento && request.altraParte?.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
				<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Cognome e nome'" [valueInput]="request.altraParte?.parte.nominativo"></div>
				<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Tipo beneficiario'"
					[valueInput]="request.altraParte && request.altraParte.categoriaAltraParte ? request.altraParte.categoriaAltraParte.descrizione : ''"></div>
				</ng-template>
				<ng-template [ngIf]="inserimento && request.altraParte?.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
				<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Ragione sociale'" [valueInput]="request.altraParte?.parte.ragioneSociale"></div>
				<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Tipo beneficiario'"
					[valueInput]="request.altraParte && request.altraParte.categoriaAltraParte ? request.altraParte.categoriaAltraParte.descrizione : ''"></div>
				</ng-template>

			</div>
			<div class="row">
				<div textInput [control]="fatturaForm.controls['numeroFattura']"
					class="col-sm-4" [labelInput]="'Numero fattura'"
					formControlName="numeroFattura" [(ngModel)]="request.numeroFattura"
					[mandatory]="true"></div>
				<div
					datePickerInput [control]="fatturaForm.controls['dataEmissione']"
					class="col-sm-4" [labelInput]="'Data fattura'"
					formControlName="dataEmissione" [(ngModel)]="request.dataEmissione"
					[mandatory]="true"></div>
				<div
					textInput class="col-sm-4" [labelInput]="'Pagata a (giorni)'"
					formControlName="numeroGiorniPagamento"
					[(ngModel)]="request.numeroGiorniPagamento"></div>
			</div>

			<hr>
			<div class="row">
				<div class="col-sm-12">
					<table class="table-striped table aggiunta_classificazione">
						<caption>Attivit&agrave; <span class="mandatory">*</span></caption>
						<ng-template [ngIf]="request.attivitaFatture?.length > 0">
						<tbody>
							<tr>
								<th>Codice</th>
								<th>Fase</th>
								<th>Attivit&agrave;</th>
								<th>Importo</th>
								<th></th>
							</tr>
							<ng-template ngFor
								let-attivitaFattura [ngForOf]="request.attivitaFatture"
								let-iAtt=index>
							<tr>
								<td>{{attivitaFattura.codice}}</td>
								<td>{{attivitaFattura.tipoFase?.label}}</td>
								<td>{{attivitaFattura.attivita}}</td>
								<td class="alignright">{{attivitaFattura.importo | euro}}
									&euro;</td>
								<td><span class="glyphicon glyphicon-trash"
									(click)="removeAttFattura(iAtt);"></span></td>
							</tr>
							</ng-template>
							<tr>
								<td></td>
								<td></td>
								<td class="alignright totale"><strong>Totale</strong></td>
								<td class="alignright totale"><strong>{{
										request.totaleImportoAttivita | euro}} &euro;</strong></td>
								<td></td>
							</tr>
						</tbody>
						</ng-template>
						<ng-template [ngIf]="request.attivitaFatture?.length == 0">
						<p>Non &egrave; presente nessuna attivit&agrave;.</p>
						</ng-template>

					</table>
				</div>
			</div>

			<ng-template [ngIf]="attFatturaForm">
			<form [formGroup]="attFatturaForm">
				<div class="row">
					 <div textInput class="form-group col-xs-12 col-sm-3" [labelInput]="'Codice'"
						[control]="attFatturaForm.controls['codice']" [checkFormat]="true"
						formControlName="codice" [(ngModel)]="newAttivitaFattura.codice"></div>

					<div comboModInput	class="col-xs-12 col-sm-3" [labelInput]="'Fase'"
						[(ngModel)]="newAttivitaFattura.tipoFase" formControlName="tipoFase"
						(change)="changeIdTipoFase($event);" [objectReference]="newAttivitaFattura.tipoFase"
						(onReturn)="newAttivitaFattura.tipoFase = $event" [optionsCombo] ="tipoFaseOptions"></div>

					<div textInput
						class="form-group col-xs-12 col-sm-3" [labelInput]="'Attivit&agrave;'"
						formControlName="attivita" [(ngModel)]="newAttivitaFattura.attivita"></div>

					<div textInputCurrency class="col-xs-12 col-sm-3" [control]="fatturaForm.controls['importo']"
						[labelInput]="'Importo'" [location]="'SezioneEconomica'"
						formControlName="importo" [(ngModel)]="newAttivitaFattura.importo"></div>
				</div>
				<div class="row">
					<p class="col-sm-2 col-xs-6 col-xs-offset-6 col-sm-offset-10">
						<button type="button" class="btn btn-primary btn-block" [disabled]="!attFatturaForm.valid"
							(click)="addAttFattura(newAttivitaFattura);">Aggiungi</button>
					</p>
				</div>
			</form>
			<hr>
			</ng-template>

			<div class="container_conteggi">
				<div>
					<p class="col-xs-12 col-sm-3 bloccodati">
						<label for="totaleattcalcolatomod">Importo totale attivit&agrave;</label>
					</p>
					<p class="col-xs-12 col-sm-offset-7 col-sm-2">
						<input id="totaleattcalcolatomod" name="totaleattcalcolatomod" disabled=""
							class="form-control totale alignright"
							value="{{ request.totaleImportoAttivita | euro}} &euro;"
							type="text">
					</p>
				</div>
				<div textInputCurrency [control]="fatturaForm.controls['speseEsenti']"
					[labelInput]="'Spese esenti'" formControlName="speseEsenti"
					[(ngModel)]="request.speseEsenti"></div>

				<div textInputCurrency [control]="fatturaForm.controls['speseImponibili']"
					[labelInput]="'Spese imponibili'" formControlName="speseImponibili"
					[(ngModel)]="request.speseImponibili"></div>

				<div comboModInput class="" [labelInput]="'Aliquota Iva'"
					formControlName="iva" [location]="'conteggi'"
					[labelOption]="'valore'" [objectReference]="request.iva"
					(onReturn)="request.iva = $event" [optionsCombo] ="ivaOptions"></div>

				<div textInputCurrency [control]="fatturaForm.controls['percentualeContributoPrevidenziale']"
					[labelInput]="'Contributo previdenziale %'" [maxValue]="100" [isNaturalNumber]="true"
					formControlName="percentualeContributoPrevidenziale"
					[(ngModel)]="request.percentualeContributoPrevidenziale"></div>

				<ng-template [ngIf]="request.percentualeContributoPrevidenziale > 0">
				<div textAreaInput class="col-sm-12"
					[labelInput]="'Descrizione contributo previdenziale'"
					formControlName="descrizioneContributoPrevidenziale"
					[(ngModel)]="request.descrizioneContributoPrevidenziale"></div>
				</ng-template>

				<div textInputCurrency [control]="fatturaForm.controls['percentualeAltreSpese']"
					[labelInput]="'Altre spese e oneri %'" [maxValue]="100"
					formControlName="percentualeAltreSpese"	[(ngModel)]="request.percentualeAltreSpese"></div>

				<ng-template [ngIf]="request.percentualeAltreSpese > 0">
				<div textAreaInput class="col-sm-12" [labelInput]="'Descrizione altre spese e oneri'"
					formControlName="descrizioneAltreSpese" [(ngModel)]="request.descrizioneAltreSpese"></div>

				</ng-template>

				<div class="">
					<p class="col-xs-6 col-sm-9 bloccodati">
						<label class="fakelabel">Applica ritenuta d'acconto</label>
					</p>
					<p class="col-xs-6 col-sm-3 active singlecheckbox">
						<input formControlName="flagRitenutaAcconto"
							id="flagRitenutaAcconto" class="alignright form-control"
							[(ngModel)]="request.flagRitenutaAcconto" type="checkbox">
						<label for="flagRitenutaAcconto"> <small class="sr-only">ritenuta d'acconto</small> </label>
					</p>
				</div>

			</div>
			<div class="row">
				<div textAreaInput class="col-xs-12 col-sm-12" [labelInput]="'Note'"
					formControlName="note" [(ngModel)]="request.note"></div>
			</div>
			<div class="row">
				<p class="mandatory col-sm-12">
					<em>* Campi obbligatori</em>
				</p>
			</div>
			<div class="row">
				<p class="col-sm-3 col-xs-6">
					<ng-template [ngIf]="inserimento">
						<button type="button" (click)="goToAssocia();"
							class="btn btn-outline-secondary btn-block">Indietro</button>
						</ng-template>
						<ng-template [ngIf]="!inserimento">
						<button type="button" class="btn btn-outline-secondary btn-block"
							(click)="createForm();">Reset</button>
					</ng-template>
				</p>
				<p class="col-sm-3 col-xs-6 col-sm-offset-6">
					<button (click)="calcolaFattura(request.altraParte);" type="button" [disabled]="(request.attivitaFatture?.length === 0) || !fatturaForm.valid"
						class="btn btn-primary btn-block">Calcola fattura</button>
				</p>
			</div>

		</form>
	</div>
</div>

<div class="col-sm-12 coldx" id="pannello11"
	[ngStyle]="{ 'display' : ( visibleToggleRiepilogo ? 'block' : 'none') }">
	<h4 id="riepilogo-fattura">Riepilogo Fattura</h4>
	<div class="tab-content">
		<form aria-labelledby="riepilogo-fattura" (ngSubmit)="save();">
			<div fattura-riepilogo-form [fattura]="request"></div>
			<div class="row">
				<p class="col-sm-3 col-xs-6">
					<button type="button" class="btn btn-outline-secondary btn-block"
						(click)="goToForm();">Indietro</button>
				</p>
				<p submitButton
					class="col-sm-3 col-xs-6 col-sm-offset-6"
					[labelButton]="'Salva'">
					<button type="button" class="btn btn-primary btn-block">Salva</button>
				</p>
			</div>
		</form>
	</div>
</div>
</ng-template>
